import './index.scss';
import { Fragment, useState, FC } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography, Chip } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import changelog from './changelog.json';

export const ChangelogPage: FC = () => {
  const [expandedList, setExpandedList] = useState([]);

  const handleChange = (panel) => (event, isExpanded) => {
    isExpanded
      ? setExpandedList((prev) => [...prev, panel])
      : setExpandedList((prev) => prev.filter((item) => item !== panel));
  };

  return (
    <div className="changelog-page">
      {changelog.map(({ releaseName, date, tickets }) => (
        <Fragment key={releaseName}>
          <div className="accordion">
            <Typography className="release__title">{`${date}: ${releaseName}`}</Typography>
            {tickets.map(({ ticket, title, description, attachments, tag }) => (
              <Accordion
                elevation={0}
                expanded={expandedList.includes(ticket)}
                onChange={handleChange(ticket)}
                key={ticket}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className="accordion__description">{title}</Typography>
                  <Chip label={tag} className={`tag-${tag}`} />
                </AccordionSummary>
                <AccordionDetails>
                  {description.map((item: string, index: number) => (
                    <Typography style={{ paddingBottom: '10px' }} key={index}>
                      {item}
                    </Typography>
                  ))}
                </AccordionDetails>
                <AccordionDetails>
                  {attachments.map(({ name, url, width, height }) => (
                    <div key={name} className="accordion__attachments">
                      <img
                        src={url}
                        alt={name}
                        {...(width && { width })}
                        {...(height && { height })}
                      />
                    </div>
                  ))}
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        </Fragment>
      ))}
    </div>
  );
};
